import { useQueries } from "@tanstack/react-query";
import { getBackendUrl } from "api/common";
import { axiosClient } from "api/http/config";
import { useQueriesWithInternalMessages } from "features/CenterContent/RoleContent/InternalMessage/utils/withInternalMessages";
import {
  StationEventResponse,
  stationEventResponse,
} from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/stationEvents/types/responseSchema";
import { log, LogLevel } from "logging/datadogBrowserLogs";
import { DefaultValues } from "react-hook-form";

export const useStationEvents = (uuids: string[]) =>
  useQueriesWithInternalMessages(
    useQueries({
      queries: uuids.map((uuid) => ({
        queryKey: ["stationEventByUuid", uuid],
        queryFn: () =>
          axiosClient
            .get<StationEventResponse>(
              `${getBackendUrl()}/station-information/information/${uuid}`,
              // signal?
            )
            .then((res) => {
              // Opinfo has different types for STATION_GENERAL_INFO and _WARNING, but for UX reasons
              // the modal form handles them as the same event with severity as a different field.
              // Therefore we have to consolidate the type here to be able to parse those events.
              const { stationInformationType } = res.data;
              let stationEvent: DefaultValues<StationEventResponse>;
              if (stationInformationType.startsWith("STATION_GENERAL")) {
                stationEvent = {
                  ...res.data,
                  stationInformationType: "STATION_GENERAL",
                };
              } else {
                stationEvent = res.data;
              }

              const { error } = stationEventResponse.safeParse(stationEvent);
              if (error) {
                log(
                  LogLevel.error,
                  "Station event response schema error",
                  error.message,
                );
              }
              return stationEventResponse.parse(stationEvent);
            }),
        staleTime: 0,
      })),
    }),
  );
